export default class Violator {
  constructor() {
    this.violator = document.querySelector('.violator');

    if (! this.violator) return;

    this.listenScroll();
  }

  listenScroll() {
    const checkPageScroll = () => {
      this.violator.classList[window.scrollY > 0 ? 'add' : 'remove']('hidden');
    };


    window.addEventListener('scroll', checkPageScroll.bind(this));
    checkPageScroll();
  }
}